import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-check-icon',
  templateUrl: 'check-icon.component.html'
})
export class CheckIconComponent {
  constructor() {}
}
